import React from "react";
import { GridLayout } from "components/grid";
import { DataDisplayRecord } from "components/data-display";
import { ShowHide } from "components/layout";
import {
    RefusedDriverDeclarationPanel,
    NoDvlaRecordPanel,
    ConflictingDetailsPanel,
} from "pages/licence-checking/grey-fleet/check/panel";
import PropTypes from "prop-types";

export function GreyFleetCheckLicenceOverview({
    isLoading,
    checkData,
    evaluateStatus,
    reloadCheck,
}) {
    return (
        <div className="spacer-bottom">
            <h2>Licence Check</h2>
            <GridLayout numberOfColumns={4} gap={30}>
                <DataDisplayRecord
                    header="Licence Status"
                    data={evaluateStatus(
                        checkData?.licence?.status,
                        checkData?.licence?.statusKey,
                        checkData?.licence?.result,
                        [
                            "LICENCEDISQUALIFIED",
                            "LICENCEPOINTLIMIT",
                            "LICENCEDECLARATIONREFUSAL",
                            "LICENCENORECORD",
                            "LICENCECONFLICTINGDETAILS",
                        ]
                    )}
                    loading={isLoading}
                />
            </GridLayout>
            <ShowHide
                evaluator={
                    !isLoading &&
                    checkData.failures.includes("LICENCEDECLARATIONREFUSAL")
                }
                show={
                    <RefusedDriverDeclarationPanel
                        checkData={checkData}
                        reloadCheck={reloadCheck}
                    />
                }
            />
            <ShowHide
                evaluator={
                    !isLoading && checkData.failures.includes("LICENCENORECORD")
                }
                show={
                    <NoDvlaRecordPanel
                        checkData={checkData}
                        reloadCheck={reloadCheck}
                    />
                }
            />
            <ShowHide
                evaluator={
                    !isLoading &&
                    checkData.failures.includes("LICENCECONFLICTINGDETAILS")
                }
                show={
                    <ConflictingDetailsPanel
                        checkData={checkData}
                        reloadCheck={reloadCheck}
                    />
                }
            />
        </div>
    );
}

GreyFleetCheckLicenceOverview.propTypes = {
    isLoading: PropTypes.bool.isRequired,
    checkData: PropTypes.object.isRequired,
    evaluateStatus: PropTypes.func.isRequired,
    reloadCheck: PropTypes.func.isRequired,
};
